import __request__ from "routing/request";
export function all(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.archive/archives", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function allForBackend(backendId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.archive/archives/backend/${backendId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteByBackend(backendId, archiveId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.archive/archives/backend/${backendId}/${archiveId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function restoreFromBackend(backendId, archiveId, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.archive/archives/backend/${backendId}/${archiveId}/restore`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkRestoreFromBackend(archives, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.archive/archives/bulkrestore", archives, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function catalog(sort = "created_at", page = 1, per_page = 50, order = "desc", query, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.archive/archives/catalog", null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function exportFilenames(sort = "created_at", exportType = "filename", query, limit = 1e4, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.archive/archives/catalog/export/${exportType}`, null, { "query": query, "limit": limit, "sort": sort }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function rebuild(requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.archive/archives/catalog/rebuild", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function checkAvailability(entryId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.archive/archives/catalog/${entryId}/available`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(archiveId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.archive/archives/${archiveId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function restore(archiveId, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.archive/archives/${archiveId}/restore`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function run(indexName, index_action = "NONE", requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.archive/archives/${indexName}`, null, { "index_action": index_action }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
